import { EnumLandingPageServiceLink } from 'src/app/enums/landing-page-service-link.enum';
import { ILandingPageService } from 'src/app/interfaces/landing-page-service.interface';

export class LandingPageServiceUtils {
    static getEmptyServices(): ILandingPageService[] {
        const services: ILandingPageService[] = [];
        for (let index = 0; index < 4; index++) {
            const service: ILandingPageService = {
                uploaded: false,
                view: null,
                show: false,
            };
            services.push(service);
        }
        return services;
    }
}
